import { PresenceChannel } from '@/realtime/channels/presence/presenceChannel';
// eslint-disable-next-line import/prefer-default-export
export class PresenceAppChannel extends PresenceChannel {
    constructor() {
        super('presence-app');
    }
}
